import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { ProtestoRow } from 'src/modules/motor-credito/serasa/serasa.pj.types'

export type ProtestoProps = {
    protesto: ProtestoRow
}

export default function Protesto({ protesto }: ProtestoProps) {
    return (
        <>
            <Divider textAlign="center">Protesto</Divider>
            {protesto && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <GridItem label="Total Ocorrências" value={protesto.total_ocorrencias.toFixed(0)} xs={6} />
                    <GridItem label="Total Valores" value={protesto.total_valores.toFixed(2)} xs={6} />

                    {protesto.ocorrencias?.map((ocorrencia, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label="Data" value={formatDate(ocorrencia.data, 'dd/MM/yyyy')} xs={6} />
                            <GridItem label="Valor" value={ocorrencia.valor.toFixed(2)} xs={6} />
                            <GridItem label="Cartório" value={ocorrencia.cartorio} xs={6} />
                            <GridItem label="Cidade" value={ocorrencia.cidade} xs={6} />
                            <GridItem label="UF" value={ocorrencia.uf} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
